import _ from 'lodash';
import multiLangHelpers from 'utils/multilanguage/helpers/multilanguage-helpers';
import { setSelectedLanguage } from 'utils/actions/selected-language/selected-language.actions';
import template from './rw-language-picker.html';

const mapStateToThis = ({ session, config, ui }) => {
  const { locale } = session;
  const { locales } = config;
  const { selectedLanguage } = ui;

  return {
    locale,
    locales,
    selectedLanguage,
  };
};
const mapDispatchToThis = {
  setSelectedLanguage,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Notifications', 'gettextCatalog')
class RwLanguagePickerController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    if (!this.language && !this.selectedLanguage) this.setSelectedLanguage(this.locale);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  checkFormValidation() {
    let formIsValid = true;
    if (this.form) {
      formIsValid = multiLangHelpers.checkFormValidation(this.form);
    }
    return formIsValid;
  }

  checkIfHasPrevLang() {
    const languageIndex = this.getLanguageIndex();
    return languageIndex ? languageIndex > 0 : false;
  }

  getLanguageIndex() {
    return _.findIndex(this.locales, { code: this.language || this.selectedLanguage });
  }

  checkIfHasNextLang() {
    const languageIndex = this.getLanguageIndex();
    return this.locales ? languageIndex < this.locales.length - 1 : false;
  }

  getPrevLang() {
    const languageIndex = this.getLanguageIndex();
    return this.locales[languageIndex - 1] ? this.locales[languageIndex - 1].code : false;
  }

  getNextLang() {
    const languageIndex = this.getLanguageIndex();
    return this.locales[languageIndex + 1] ? this.locales[languageIndex + 1].code : false;
  }

  onLanguageChange(next) {
    if (this.checkFormValidation()) {
      let languageIndex = this.getLanguageIndex();
      if (next) {
        languageIndex++;
      } else {
        languageIndex--;
      }
      const locale = this.locales[languageIndex].code;
      if (!this.language) this.setSelectedLanguage(locale);
      if (this.language) this.language = locale;

      if (typeof this.onLanguageSelect === 'function') {
        this.onLanguageSelect({ locale });
      }
    } else {
      this.Notifications.alertWarning(this.gettextCatalog.getString('Validation failed. Please review errors.'));
    }
  }
}

export default class RwLanguagePickerComponent {
  constructor() {
    this.template = template;
    this.controller = RwLanguagePickerController;
    this.bindings = {
      form: '<',
      onLanguageSelect: '&?',
      language: '<?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/multilanguage/components/rw-language-picker/rw-language-picker-component.js